import Product from './Product';

// TODO: Refactor for MST Model
export default function ChildProduct() {
  return Product.named('ChildProduct');
}
